export default function Footer() {
  const footerLinks = [
    {
      title: '内容分类',
      links: [
        { label: '电影大全', href: '#index' },
        { label: '电视剧集', href: '#index' },
        { label: '动漫番剧', href: '#index' },
        { label: '综艺娱乐', href: '#index' },
        { label: '午夜剧场', href: '#index' },
      ],
    },
    {
      title: '热门资源',
      links: [
        { label: '香蕉视频', href: '#carousel' },
        { label: '红桃视频', href: '#carousel' },
        { label: '91视频', href: '#carousel' },
        { label: '蜜桃视频', href: '#carousel' },
        { label: '高清专区', href: '#carousel' },
      ],
    },
    {
      title: '快捷入口',
      links: [
        { label: '常见问题', href: '#faq' },
        { label: '最新动态', href: '#updates' },
        { label: 'APP下载', href: '#app' },
        { label: '联系我们', href: '#contact' },
        { label: '关于我们', href: '#about' },
      ],
    },
    {
      title: '合作伙伴',
      links: [],
    },
  ];

  const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-200 border-t border-background-400/30">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-8">
          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-bold text-foreground-800 mb-4 whitespace-nowrap">
                {group.title}
              </h4>
              {group.links.length > 0 ? (
                <ul className="space-y-2.5">
                  {group.links.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        onClick={(e) => handleLinkClick(e, link.href)}
                        className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="text-sm text-foreground-500">诚邀优质平台合作</p>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-400/20">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-2">
              <div className="w-7 h-7 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-fill text-background-50 text-sm"></i>
              </div>
              <span className="text-sm font-bold text-foreground-700 whitespace-nowrap">
                苹果视频
              </span>
              <span className="text-xs text-foreground-500 whitespace-nowrap">
                - 免费高清电影电视剧流畅播放不缓冲
              </span>
            </div>
            <div className="flex items-center gap-4 text-xs text-foreground-500 whitespace-nowrap">
              <span>Copyright &copy; 2026 苹果视频</span>
              <span className="hidden sm:inline">|</span>
              <span>All Rights Reserved</span>
            </div>
          </div>
          <p className="mt-4 text-xs text-foreground-500 text-center sm:text-left leading-relaxed">
            苹果视频提供免费高清电影电视剧在线观看，汇聚香蕉视频、红桃视频、91视频、蜜桃视频等热门资源，全集免费在线观看。本站所有内容均来自互联网公开资源，仅供学习交流使用。
          </p>
        </div>
      </div>
    </footer>
  );
}